"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalOAuthError = void 0;
function isExternalOAuthError(error) {
    return error.message === 'External OAuth did not respond in time.';
}
exports.isExternalOAuthError = isExternalOAuthError;
//# sourceMappingURL=error.js.map